import React, { createContext, useContext } from 'react';
import { useApplicationsByPassport } from '../data/useApplicationsByPassport';

type Value = ReturnType<typeof useApplicationsByPassport>;

const ApplicationsContext = createContext<Value | null>(null);

export function UniqueApplicationsListProvider({
  passportId,
  currentApplicationId,
  children,
}: {
  passportId: string;
  currentApplicationId: string;
  children: React.ReactNode;
}) {
  const value = useApplicationsByPassport(passportId, currentApplicationId);
  return <ApplicationsContext.Provider value={value}>{children}</ApplicationsContext.Provider>;
}

export function useUniqueApplicationsListContext() {
  const ctx = useContext(ApplicationsContext);
  return ensureContext(ctx);
}

export function ensureContext<T>(ctx: T | null): T {
  if (ctx == null) {
    throw new Error('useUniqueApplicationsListContext must be used within an UniqueApplicationsListProvider');
  }
  return ctx;
}
